export default "__VITE_ASSET__BWd8wWiX__"